(ns frontend.view.nev.oppo.view
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.features.plan :as plan]
   [common.localization :as loc]
   [common.roles :as roles]
   [common.schema.field :as field]
   [common.sync-progress :as sync-progress]
   [common.util :as cu]
   [frontend.actions.deal :as deal-actions]
   [frontend.db :as app-db]
   [frontend.logging :as logging]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.utils :as fu]
   [frontend.ux-overhaul.nev.view :as new-nev]
   [frontend.view.entity-viewers.components :as nev-components]
   [frontend.view.entity-viewers.entity-editor :as entity-editor]
   [frontend.view.entity-viewers.event-pane :as event-pane]
   [frontend.view.entity-viewers.header :as header]
   [frontend.view.entity-viewers.modules :as modules]
   [frontend.view.entity-viewers.modules.associated-entities :as associated-entities]
   [frontend.view.entity-viewers.modules.check-list.view :as check-list-module]
   [frontend.view.entity-viewers.modules.fees :as fees]
   [frontend.view.entity-viewers.modules.guests :as guests-module]
   [frontend.view.entity-viewers.modules.risk.event :as risk-event]
   [frontend.view.entity-viewers.modules.risk.view :as risk-module]
   [frontend.view.entity-viewers.utils :as entity-utils]
   [frontend.view.field-templates :as templates]
   [frontend.view.modals.ai-deal-one-pager.view :as ai-deal-one-pager]
   [frontend.view.modals.change-pipeline.view :as change-pipeline]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.memo.view :as memo]
   [frontend.view.nev.events :as events]
   [frontend.view.nev.oppo.event :as event]
   [frontend.view.nev.oppo.events :as oppo-events]
   [frontend.view.nev.oppo.sub :as sub]
   [frontend.view.not-found :as not-found]
   [frontend.view.syncing-data :as syncing]
   [potpuri.core :refer [fn->]]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [reagent.ratom :as ratom]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]

   [ui.dom-globals :as dg]
   [ui.view.transaction-process.target-transactions :as target-transactions]
   [ui.view.nev.view :as nev-2024]))

(def fees-associated-entities-attributes
  [:common/related-entities-company
   :common/related-entities-person])

(defn toolbar-buttons
  [{:keys [entity]}]
  (let [entity-id (:db/id entity)
        flagged? (or (contains? (:oppo/flagged-by entity)
                                (:db/id @session/account))
                     (contains? (:account/flagged-entities @session/account)
                                entity-id))]
    (->>
     (concat
      [(zap-toolbar/dropdown-button
        {:icon      :fa-star
         :on-select (partial deal-actions/toggle-flag entity flagged?)
         :ord       1
         :label     (loc/tr (if flagged? :unflag-entity-menu-item :flag-entity-menu-item))})]
      (when-not (session/is-read-only-user?)
        [(zap-toolbar/dropdown-button
          {:icon             :fa-ban
           :label            (loc/tr :pass)
           :ord              2
           :custom-style     "zap-btn__solid__salmon"
           :dropdown-color   "salmon"
           :dropdown-action? (not= (:oppo/status entity) :oppo.status/passed)
           :on-select        (partial oppo-events/start-pass! entity)})
         (zap-toolbar/dropdown-button
          {:icon             :fa-pause
           :label            (loc/tr :put-on-hold)
           :ord              3
           :custom-style     "zap-btn__solid__yellow"
           :dropdown-color   "yellow"
           :dropdown-action? (not= (:oppo/status entity) :oppo.status/on-hold)
           :on-select        (partial oppo-events/start-put-on-hold! entity)})
         (zap-toolbar/dropdown-button
          {:icon             :fa-redo-alt
           :label            (loc/tr :activate)
           :ord              4
           :custom-style     "zap-btn__solid__blue"
           :dropdown-color   "blue"
           :dropdown-action? (not= (:oppo/status entity) :oppo.status/ok)
           :hidden?          (fn []
                               (not (some #{(:oppo/status entity)}
                                          [:oppo.status/on-hold :oppo.status/passed])))
           :on-select        #(oppo-events/resurrect! (:db/id entity))})])

      [(zap-toolbar/dropdown-button
        {:icon             :fa-check
         :label            (loc/tr :portfolio)
         :ord              5
         :custom-style     "zap-btn__solid__green"
         :dropdown-color   "green"
         :dropdown-action? (not= (:oppo/status entity) :oppo.status/portfolio)
         :hidden?          (fn []
                             (some #{(:oppo/status entity)}
                                   [:oppo.status/portfolio :oppo.status/passed]))
         :on-select        #(oppo-events/start-to-portfolio! entity)})]

      (when-not (:common/disabled? entity)
        [(zap-toolbar/delete-button entity [:oppos-grid])])

      (when (f-permissions/field-write-access? :common/attachments
                                               (:entity/type entity)
                                               (:oppo/pipeline entity))
        [(zap-toolbar/dropdown-button {:on-select identity
                                       :divider   true
                                       :ord       20
                                       :label     (loc/tr :deal-secondary-menu-header-summaries)})
         (when (and (session/has-feature-access? :feature/ai-deal-parsing)
                    (not (session/is-read-only-user?)))
           (zap-toolbar/dropdown-button
            {:dropdown-action? true
             :icon :fa-robot
             :ord 24
             :on-select (fn []
                          (ai-deal-one-pager/open!
                           (:db/id entity)
                           (-> entity :oppo/pipeline :db/id)))
             :label (loc/tr :deal-one-pager/menu-item)}))
         (zap-toolbar/dropdown-button {:dropdown-action? true
                                       :icon             :fa-file-word
                                       :ord              23
                                       :on-select        #(modals/open-modal! memo/modal-key
                                                                              {:oppo-id            (:db/id entity)
                                                                               :skip-blank-values? true
                                                                               :full?              true})
                                       :label            (loc/tr :deal-menu-item-memorandum-full-no-blanks)})])
      [(zap-toolbar/dropdown-button
        {:dropdown-action? true
         :icon             :fa-file-word
         :ord              21
         :on-select        #(modals/open-modal! memo/modal-key {:oppo-id (:db/id entity)})
         :label            (loc/tr :deal-menu-item-memorandum)})
       (zap-toolbar/dropdown-button {:dropdown-action? true
                                     :icon             :fa-file-word
                                     :ord              22
                                     :on-select        #(modals/open-modal! memo/modal-key
                                                                            {:oppo-id (:db/id entity)
                                                                             :full?   true})
                                     :label            (loc/tr :deal-menu-item-memorandum-full)})
       (when (session/has-feature-access? :feature/pdf-memo)
         (zap-toolbar/dropdown-button
          {:dropdown-action? true
           :icon             :fa-file-pdf
           :ord              25
           :on-select        #(routing/set-view! [:pdf-memo :id (:db/id entity)])
           :label            (loc/tr :deal-menu-item-pdf-memorandum)}))]

      [(nev-components/audit-trail-button {:entity entity})])
     (remove nil?))))

(def target-types
  (concat (when-not (session/is-guest?)
            [:entity.type/investor
             :entity.type/person
             :entity.type/oppo])
          (when (session/portfolio?)
            [:entity.type/holding])))

(defn deal-modules
  [{:keys [module-collapsed-path state-atom notification-atom error-atom original-pipeline-id
           oppo-id header-fields view-id existing-guests is-guest?]}]
  (let [oppo (get @session/entities oppo-id)
        pipeline (get @session/entities (:oppo/pipeline oppo))
        tenant-schema @session/tenant-schema
        capman-re? (tenant-customizations/capman-is-real-estate-pipeline? original-pipeline-id)
        id->entity @(rf/subscribe [::sub/id->entity])
        oppo-view-subscription-initial-data-loaded? @(rf/subscribe [::sub/initial-data-loaded?])
        entity-viewer-args {:state-atom                                  state-atom
                            :view-id                                     view-id
                            :module-id                                   :oppo-information
                            :containing-entity                           oppo
                            :ordering                                    (get-in
                                                                          @session/view-config
                                                                          [view-id :modules :module-config :oppo-information
                                                                           :ordering])
                            :id->entity                                  id->entity
                            :oppo-view-subscription-initial-data-loaded? oppo-view-subscription-initial-data-loaded?}
        check-list-fields (->> pipeline
                               :pipeline/checklist-configurations
                               (mapcat (fn [checklist-id]
                                         (let [checklist-entity (session/get-entity (or (:db/id checklist-id)
                                                                                        checklist-id))]
                                           (when (= (:check-list/target-entity-type checklist-entity)
                                                    (:entity/type oppo))
                                             (->> checklist-entity
                                                  :check-list/configuration)))))
                               (distinct))]
    (concat
     [{:module-id              :oppo-information
       :header                 (loc/tr :nev-module/about-this-entity-type
                                       [(string/lower-case (loc/tr (:entity/type oppo)))])
       ;;TODO uncomment when finished:
       #_:header-tools
       #_(when (session/is-admin?)
           [:span.entity-editor-header-settings
            {:on-click (fn [e])}
            ;;open settings

            [:span (loc/tr :entity-editor/settings-label)]
            [:i.fal.fa-cog]])
       :collapsed?             (get-in @session/view-config (module-collapsed-path :oppo-information))
       :save-module-collapsed! (partial events/save-module-collapsed! :entity.type/oppo)
       :content
       [:div
        [entity-editor/view
         (merge
          entity-viewer-args
          {:custom-save!  (fn [attribute new-value on-success! on-error!]
                            (when (= attribute :oppo/pipeline)
                              (modals/open-modal! change-pipeline/modal-key
                                                  {:ofs-opportunity      oppo
                                                   :selected-pipeline-id new-value
                                                   :original-pipeline-id original-pipeline-id
                                                   :on-close!            (on-success!)})
                              ;; call pipeline select error! to revert select value
                              (on-error!)
                              true))
           :entity-id     oppo-id
           :remove-fields (concat [:oppo/name :oppo/target-asset :common/network-drive :common/named-network-drives]
                                  (when (tenant-customizations/capman?)
                                    [:oppo/pipeline])
                                  (-> (field/entity-tag-fields tenant-schema (:entity/type oppo))
                                      (set)
                                      (disj
                                       (when capman-re?
                                         :oppo/tag-country))
                                      (into []))
                                  header-fields
                                  check-list-fields
                                  (when-not (= :oppo.status/passed (:oppo/status oppo))
                                    [:oppo/pass-reason-v2 :oppo/pass-reason-secondary]))})]]}]
     (target-transactions/module-configs
      {:target                  oppo
       :create-initial-values   {:short-name (:oppo/name oppo)
                                 :vehicle-id (or (-> oppo :oppo/fund :db/id)
                                                 (:oppo/fund oppo))}
       :module-collapsed-path   module-collapsed-path
       :save-module-collapsed! (partial events/save-module-collapsed!
                                        :entity.type/oppo)})
     [(when (and (or (:oppo/target-asset oppo)
                     (not is-guest?))
                 (or (not (tenant-customizations/capman?))
                     (not (tenant-customizations/capman-in-real-estate-pipeline?))))
        (let [module-id :oppo-asset
              asset-type (->> oppo
                              :oppo/target-asset
                              (get @session/entities)
                              :entity/type)
              order-config-path [view-id :modules :module-config module-id asset-type :ordering]
              collapsed-path (module-collapsed-path module-id)
              collapsed? (get-in @session/view-config collapsed-path)]
          (nev-components/entity-relation-module
           {:state-atom             state-atom
            :module-id              module-id
            :view-id                view-id
            :ordering               (get-in
                                     @session/view-config
                                     order-config-path)
            :order-config-path      order-config-path
            :module-label           ;(if (:oppo/target-asset oppo)
                                     ; (loc/tr :nev-module/existing-target-asset [(loc/tr asset-type)])
            (loc/tr :nev-module/oppo-target-asset);)
            :entity                 oppo
            :id->entity             id->entity
            :forced-entity-types    (or (some->> oppo
                                                 :oppo/pipeline
                                                 (get @session/entities)
                                                 :pipeline/target-asset-types)
                                        [])                                                         ;; empty list as not to crash the app if pipeline is not found for any reason
            :pipeline-id            (->> oppo
                                         :oppo/pipeline)
            :relationship-attribute :oppo/target-asset
            :header-tools
            [:span.grow.flex.justify-end
             (when (and (not is-guest?)
                        (:oppo/target-asset oppo)
                        (not collapsed?)
                        (not (session/is-read-only-user?)))
               [nev-components/remove-attribute-icon
                {:entity    oppo
                 :attribute :oppo/target-asset}])

             (when (some->> oppo
                            :oppo/target-asset
                            (get @session/entities)
                            :asset/city)
               [button/secondary-open
                {:tooltip (loc/tr :open-address-in-google-maps)}
                [:i.fal.fa-map-marker-alt
                 {:on-click (fn [_]
                              (let [asset (->> oppo
                                               :oppo/target-asset
                                               (get @session/entities))]
                                (dg/open-window (str "https://www.google.com/maps/place/"
                                                     (when-let [address (:asset/street-address asset)]
                                                       (str address ","))
                                                     (when-let [zip (:asset/zip-code asset)]
                                                       (str zip "+"))
                                                     (:asset/city asset)))))}]])]})))]

     [(when (session/has-feature-access? :feature/pre-investment-checks)
        (let [module-id :pre-investment-checks
              asset-type (->> oppo
                              :oppo/target-asset
                              (get @session/entities)
                              :entity/type)
              order-config-path [view-id :modules :module-config module-id asset-type :ordering]]
          (nev-components/pre-investment-checks-module
           {:state-atom             state-atom
            :module-id              module-id
            :view-id                view-id
            :ordering               (get-in
                                     @session/view-config
                                     order-config-path)
            :order-config-path      order-config-path
            :module-label           (loc/tr :nev-module/pre-investment-checks)
            :entity                 oppo
            :relationship-attribute :oppo/target-asset})))]

     [(when (session/decisions?)
        (let [module-id :decisions
              asset-type (->> oppo
                              :oppo/target-asset
                              (get @session/entities)
                              :entity/type)
              order-config-path [view-id :modules :module-config module-id asset-type :ordering]]
          (nev-components/decisions-module
           {:state-atom             state-atom
            :module-id              module-id
            :view-id                view-id
            :ordering               (get-in
                                     @session/view-config
                                     order-config-path)
            :order-config-path      order-config-path
            :module-label           (loc/tr :nev-module/decisions)
            :entity                 oppo
            :relationship-attribute :oppo/target-asset})))]

     (when (or (session/counterparty-diligence?)
               (session/counterparty-diligence-admin?))
       (let [module-id :counterparty-diligences
             order-config-path [view-id :modules :module-config module-id :ordering]]
         [(nev-components/counterparty-diligences-module
           {:state-atom             state-atom
            :module-id              module-id
            :view-id                view-id
            :ordering               (get-in
                                     @session/view-config
                                     order-config-path)
            :order-config-path      order-config-path
            :module-label           (loc/tr :counterparty-diligences)
            :entity                 oppo})]))

     [(when (session/has-feature-access? :feature/entity-esign)
        (let [module-id :entity-esign]
          (nev-components/entity-esign-module
           {:view-id      view-id
            :module-id    module-id
            :module-label (loc/tr :nev-module/entity-esign)
            :entity       oppo})))]

     (when (and (session/risks-access?)
                (f-permissions/field-read-access? :oppo/risk-entities
                                                  :entity.type/oppo
                                                  original-pipeline-id))
       [(risk-module/risk-module-config
         {:module-label           (loc/tr :nev-module/oppo-risks)
          :module-id              :oppo-risks
          :view-id                view-id
          :nev-entity-type        :entity.type/oppo
          :save-collapsed-status! (r/partial events/save-module-collapsed!
                                             (:entity/type
                                              :entity.type/oppo))
          :entity-id              oppo-id
          :add-new-button?        false})])

     (when-not (session/is-guest?)
       (associated-entities/modules {:entity-id              oppo-id
                                     :save-module-collapsed! events/save-module-collapsed!
                                     :module-collapsed-path  module-collapsed-path}))
     (when (session/fee-tracking?)
       (fees/modules {:entity-id                           oppo-id
                      :save-module-collapsed!              events/save-module-collapsed!
                      :module-collapsed-path               module-collapsed-path
                      :fees-associated-entities-attributes fees-associated-entities-attributes}))

     (when (and (not (session/is-guest?))
                (plan/available :feature/buy-side-guest @session/tenant @session/role)
                (or (seq existing-guests)
                    (not (session/is-read-only-user?))))
       [{:module-id              :guest-accounts
         :header                 (loc/tr :nev-module/guest-accounts)
         :collapsed?             (get-in @session/view-config (module-collapsed-path :guest-accounts))
         :save-module-collapsed! (partial events/save-module-collapsed! (:entity/type oppo))
         :start-collapsed?       (empty? existing-guests)
         :content                [:div
                                  [guests-module/view
                                   {:entity-id          oppo-id
                                    :fields             [{:attribute :role/guest-buy-side
                                                          :label     (loc/tr :buy-side-guests)}]
                                    :show-notification! (partial events/show-notification!
                                                                 notification-atom)
                                    :show-error!        (partial events/show-error! error-atom)
                                    :guest-roles        existing-guests}]]}])

     (when (not (session/is-guest?))
       (->> pipeline
            :pipeline/checklist-configurations
            (keep (fn [checklist-id]
                    (let [checklist-entity (session/get-entity (or (:db/id checklist-id)
                                                                   checklist-id))
                          module-id (keyword (str "check-list-" checklist-id))]
                      (when (= (:check-list/target-entity-type checklist-entity)
                               (:entity/type oppo))
                        {:module-id              module-id
                         :header                 (:check-list/label checklist-entity)
                         :collapsed?             (get-in @session/view-config (module-collapsed-path module-id))
                         :save-module-collapsed! (partial events/save-module-collapsed! (:entity/type oppo))
                         :start-collapsed?       true
                         :header-tools           [check-list-module/header-view tenant-schema oppo-id checklist-id]
                         :content                [:div
                                                  [check-list-module/view
                                                   {:parent-entity-id    oppo-id
                                                    :checklist-entity-id checklist-id
                                                    :fields              [{:attribute :role/guest-buy-side
                                                                           :label     (loc/tr :buy-side-guests)}]}]]}))))))

     (when (and (not (session/is-mobile?))
                (f-permissions/field-read-access? :common/attachments
                                                  :entity.type/oppo
                                                  (->> oppo
                                                       :oppo/pipeline)))
       [(nev-components/attachments-module view-id :oppo-attachments oppo)]))))

(defn header-top
  [{:keys [entity read-only?]}]
  [:div
   {:class "flex gap-2"}
   [:span
    {:class "text-2xl"}
    [:i {:class-name (fu/cs :fal (entity/default-icon entity))}]]
   [:div
    [nev-components/name-view
     {:entity     entity
      :read-only? read-only?}]]])

(defn default-field-defs
  [oppo]
  (let [original-pipeline-id (:oppo/pipeline oppo)
        capman-re? (tenant-customizations/capman-is-real-estate-pipeline? original-pipeline-id)
        thuja-capital-management? (tenant-customizations/thuja-capital-management?)]
    (cond
      capman-re?
      [{:fields       {0 {:field :oppo/deal-description}
                       1 {:field :oppo/case-note}
                       2 {:field :oppo/status-and-next-steps}}
        :field-layout :f-4}]

      thuja-capital-management?
      [{:fields       {0 {:field :oppo/status-and-next-steps}}
        :field-layout :f-4}]

      :else
      [{:fields       {0 {:field :oppo/case-note}
                       1 {:field :oppo/status-and-next-steps}}
        :field-layout :f-2-2}])))

(defn header-board
  [{:keys [entity-atom entity-id]}]
  (let [header-state (r/atom {:edit-layout? false #_true})
        set-edit-layout! (fn [val] (swap! header-state assoc :edit-layout? val))]
    (fn [_ #_{:keys [entity-atom]}]
      (let [edit-layout? (:edit-layout? @header-state)
            entity @entity-atom
            field-defs-path [:deal :header :field-defs]
            field-defs-timeout-id :oppo-field-defs
            field-defs (or (events/timeout-value field-defs-timeout-id
                                                 @(r/track session/get-view-config field-defs-path))
                           (default-field-defs entity))
            selected-fields (->> field-defs
                                 (map :fields)
                                 (mapcat vals)
                                 (keep :field))
            ;;TODO first release: target-asset not editable via curtain:
            overrides {:oppo/target-asset {:field/default-visibilty {:editor :editor.type/link}}
                       ;;:oppo/stage not editable via nev-editor-curtain for now. can be changed via separate ui
                       ;; (and :entity/update-attributes is missing :move audit-element handling)
                       :oppo/stage        {:editor/type :editor.type/select
                                           :read-only?  true}}
            remove-fields #{:oppo/ratings}
            oppo-schema (templates/entity-type-template
                         {:entity-type     :entity.type/oppo
                          :selected-fields selected-fields
                          :tenant-schema   @session/tenant-schema
                          :account         @session/account
                          :role            @session/role
                          :remove-fields   remove-fields
                          :overrides       overrides})

            asset-system-fields [:company/intelligence-company
                                 :company/fullcontact-company]
            remove-asset-fields asset-system-fields
            target-asset-schema (templates/oppo-target-asset-template
                                 {:selected-fields (->> selected-fields
                                                        (filter vector?)
                                                        (filter (fn-> count (= 2)))
                                                        (filter (fn-> first (= :oppo/target-asset)))
                                                        (map last))
                                  :remove-fields   remove-asset-fields
                                  :tenant          @session/tenant
                                  :tenant-schema   @session/tenant-schema
                                  :account         @session/account
                                  :role            @session/role
                                  :overrides       {:asset/name {:editor/type :editor.type/link
                                                                 :read-only?  true}}})
            schema (concat oppo-schema
                           (->> target-asset-schema
                                (map (fn [[k fs]]
                                       (let [ref-attribute [:oppo/target-asset k]]
                                         [ref-attribute
                                          (assoc fs :label (templates/target-asset-label fs))])))))

            ;;test all fields:
            #_#_field-defs
              (->> schema
                   (map first)
                   (partition-all 4 4)
                   (map (fn [fields]
                          (->> fields
                               (map-indexed (fn [i f]
                                              [i {:field f}])))))
                   (map (partial into {}))
                   (map (fn [fields]
                          {:fields       fields
                           :field-layout :f-1-1-1-1}))
                   vec)]
        [header/header-board
         {:top              [header-top {:entity entity}]
          :preview-top      [header-top
                             {:entity     entity
                              :read-only? true}]
          :actions          (toolbar-buttons {:entity entity})
          :entity-id        entity-id
          :entity-atom      entity-atom
          :edit-layout?     edit-layout?
          :set-edit-layout! set-edit-layout!
          :field-defs       field-defs
          :schema           schema
          :save-layout!     (fn [new-field-defs]
                              (events/save-field-defs! field-defs-timeout-id
                                                       field-defs-path
                                                       new-field-defs
                                                       (fn [])
                                                       (fn [err]
                                                         (logging/error
                                                          "Failed to save field layout"
                                                          err))))}]))))

(defn new-header?
  []
  (and (session/has-feature-access? :feature/customizable-nev)
       @session/customizable-nev?))

(defn oppo-view
  [{:keys [oppo-id]}]
  (let [initialized? (r/atom false)
        state-atom (r/cursor app-db/app-state [:views :nev :oppo])
        temp-atom (r/cursor state-atom [:temp])
        view-state-atom (r/cursor state-atom [:view-state])
        error-atom (r/cursor state-atom [:error])
        notification-atom (r/cursor state-atom [:notification])
        entity-sort (fn-> entity/display-string string/lower-case)
        view-id :deal
        module-collapsed-path (fn [module-id]
                                [view-id :modules :module-config module-id :collapsed?])
        r-existing-guests (ratom/reaction
                           (->> @session/all-roles
                                (cu/only-entity :role/role :role/guest-buy-side)
                                (remove :common/disabled?)
                                (cu/only-entity :role/target oppo-id)
                                doall))
        entity-atom (r/cursor session/entities [oppo-id])
        oppo (get @session/entities oppo-id)
        original-pipeline-id (:oppo/pipeline oppo)]
    (r/create-class
     {:component-did-update
      (partial entity-utils/component-did-update
               :oppo-id
               (partial events/clear-errors! error-atom notification-atom))
      :component-did-mount
      (fn [_]
        (entity-utils/reset-state! state-atom oppo-id
                                   {:always-fetch? (session/new-grid-2023?)})
        (reset! initialized? true)
        (rf/dispatch [::event/open-oppo-view-subscription oppo-id])
        ;; A record that is not loaded yet has no pipeline. Keep the pipeline of the
        ;; listing, so that the back link opens the same pipeline.
        (when (some? original-pipeline-id)
          (swap! session/selected-pipelines assoc
                 :oppo-pipeline
                 original-pipeline-id))
        (when (and (session/risks-access?)
                   (f-permissions/field-read-access? :oppo/risk-entities
                                                     :entity.type/oppo
                                                     original-pipeline-id))
          (rf/dispatch [::risk-event/load-risks oppo-id])))
      :component-will-unmount
      (fn [_]
        (rf/dispatch [::event/close-oppo-view-subscription])
        (events/clear-errors! error-atom notification-atom)
        (entity-utils/clear-state! state-atom))
      :reagent-render
      (fn [{:keys [oppo-id] :as view-args}]
        (let [oppo (get @session/entities oppo-id)
              original-pipeline-id (:oppo/pipeline oppo)
              capman-re? (tenant-customizations/capman-is-real-estate-pipeline?
                          original-pipeline-id)
              thuja-capital-management? (tenant-customizations/thuja-capital-management?)
              header-fields (cond capman-re?
                                  [:oppo/deal-description :oppo/status-and-next-steps]
                                  thuja-capital-management?
                                  [:oppo/status-and-next-steps]
                                  :else
                                  ;; TODO: configuration for user
                                  [:oppo/case-note :oppo/status-and-next-steps])]
          (cond
            (not @initialized?)
            [syncing/view]
            (or (:common/disabled? oppo)
                (:not-found @state-atom))
            [not-found/not-found-content]
            (:loading @state-atom)
            [syncing/view]
            :else
            (if (or (not oppo)
                    (:common/disabled? oppo))
              [:div " "]
              (let [tenant @session/tenant
                    existing-guests @r-existing-guests
                    module-args (merge view-args
                                       {:state-atom            state-atom
                                        :oppo                  oppo
                                        :view-id               view-id
                                        :original-pipeline-id  original-pipeline-id
                                        :header-fields         header-fields
                                        :temp-atom             temp-atom
                                        :view-state-atom       view-state-atom
                                        :error-atom            error-atom
                                        :notification-atom     notification-atom
                                        :entity-atom           entity-atom
                                        :tenant                tenant
                                        :entity-sort           entity-sort
                                        :existing-guests       existing-guests
                                        :module-collapsed-path module-collapsed-path})]
                [:<>
                 (when-not (session/is-guest?)
                   [zap-toolbar/nev-toolbar
                    {:state            state-atom
                     :label            (partial zap-toolbar/toolbar-back
                                                [:oppos-grid]
                                                (loc/tr :back-to/oppos-grid))
                     :actions          (toolbar-buttons (assoc view-args
                                                               :entity oppo))
                     :dropdown-trigger [dropdown-menu/button-trigger
                                        {:label (loc/tr :actions)
                                         :icon  [:i.fas.fa-angle-down.ml-2]}]}])
                 [:div.entity__container
                  (when @error-atom
                    [nev-components/error-bar error-atom])
                  (when @notification-atom
                    [nev-components/notification-bar notification-atom])

                  [:div.entity
                   [:div
                    {:class "w-full max-w-[1920px] mx-auto p-4"}
                    (when-not (session/is-guest?)
                      [nev-components/owner-stage-rating-module
                       {:entity-cursor            entity-atom
                        :view-state               view-state-atom
                        :entity                   oppo
                        :entity-stage-attribute   :oppo/stage
                        :stage-entity-type        :entity.type/stage
                        :stage-pipeline-id        (:oppo/pipeline oppo)
                        :stage-pipeline-attribute :stage/pipeline
                        :ratings-attribute        :oppo/ratings
                        :owner-attribute          :oppo/owner
                        :members-attribute        :common/team-members}])
                    (if (new-header?)
                      [header-board
                       {:entity-id   oppo-id
                        :entity-atom entity-atom}]
                      [nev-components/header-module
                       {:component-state        temp-atom
                        :view-state             view-state-atom
                        :related-tags-entity-id (:oppo/target-asset oppo)
                        :entity                 oppo
                        :pipeline-id            original-pipeline-id
                        :selected-fields        header-fields}])

                    [:div
                     {:class "md:grid grid-cols-10 gap-4"}
                     [:div
                      {:class (if (session/event-pane-disabled?)
                                "col-span-10"
                                "col-span-10 lg:col-span-5")}
                      [:div
                       [modules/view
                        {:view-id             view-id
                         :ordering            (get-in @session/view-config [view-id :modules :ordering])
                         :save-modules-order! (partial events/save-modules-order!
                                                       (:entity/type oppo))
                         :modules             (deal-modules module-args)}]]]
                     (when-not (session/event-pane-disabled?)
                       [:div
                        {:class "col-span-10 lg:col-span-5"}
                        [event-pane/view
                         {:entity-ids  (remove nil?
                                               [oppo-id
                                                (:oppo/target-asset oppo)])
                          :module-args {:state-atom state-atom
                                        :view-id    view-id}}]])]]]]])))))})))

(defn new-oppo-viewer-wrapper
  [{:keys [oppo-id]}]
  (let [state-path [:nev-2024 :deal oppo-id]]
    [:div
     ;; FIXME: height hack with navbar height
     {:class "h-[calc(100vh-52px)] overflow-hidden"}
     [nev-2024/view
      {:entity-id   oppo-id
       :entity-type :entity.type/oppo
       :state-path  state-path}]]))

(defn oppo-view-wrapper
  [{:keys [oppo-id]}]
  (let [classic-entity-viewer-enabled? @(r/track session/classic-entity-viewer-enabled?)
        ;; TODO
        oppo-nev-2024-implemented? false]
    (if (or classic-entity-viewer-enabled? (not oppo-nev-2024-implemented?))
      [oppo-view {:oppo-id oppo-id}]
      [new-oppo-viewer-wrapper {:oppo-id oppo-id}])))

(defmethod routing/render-view :entity.type/oppo
  [{:keys [route-params]}]
  (let [oppo-id (-> route-params
                    :id
                    js/parseInt)]
    (if @session/new-nev-in-use?
      [default-page-layout/view
       {:class-name "zap-page oppo"}
       ;;the key change forces rerendering of the component (and its child components)
       ^{:key (str "oppo-viewer-id-" oppo-id)}
       [new-nev/view {:oppo-id oppo-id}]]
      [default-page-layout/view
       {:class-name "zap-page oppo"}
       ;;the key change forces rerendering of the component (and its child components)
       ^{:key (str "oppo-viewer-id-" oppo-id)}
       [oppo-view-wrapper {:oppo-id oppo-id}]])))

(defmethod routing/render-view :deal-guest
  [_]
  ;; TODO can also pass roles here to enable buy-side-guests later
  [syncing/wait-until-sync-progress sync-progress/COMPLETE
   (if-not (roles/is-guest-role? @session/role)
     [not-found/not-found-view]
     [default-page-layout/view
      {:class-name "zap-page oppo"}
      ^{:key (str "deal-viewer-id-" @entity-utils/force-remount-atom)}
      [oppo-view
       {:oppo-id @session/target-id}]])])
